import * as React from "react"

const BarcodeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    style={{
      enableBackground: "new 0 0 512 512",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path d="M0 73.956h34.133v364.089H0zM477.867 73.956H512v364.089h-34.133zM79.644 73.956h34.133v295.822H79.644zM79.644 403.911h34.133v34.133H79.644zM159.289 73.956h34.133v295.822h-34.133zM159.289 403.911h34.133v34.133h-34.133zM238.933 73.956h34.133v295.822h-34.133zM238.933 403.911h34.133v34.133h-34.133zM318.578 73.956h34.133v295.822h-34.133zM318.578 403.911h34.133v34.133h-34.133zM398.222 73.956h34.133v295.822h-34.133zM398.222 403.911h34.133v34.133h-34.133z" />
  </svg>
)

export default BarcodeIcon